import { Component } from '@angular/core';

@Component({
  selector: 'lib-petronas-icon',
  standalone: true,
  imports: [],
  templateUrl: './petronas-icon.component.html',
  styleUrl: './petronas-icon.component.css',
})
export class PetronasIconComponent {}
